import { post, get, baseURL } from "@/utils/request";

export const getUserFundHistory = (params: any) => get(`/user/userFundFlowHistory?logType=${params.logType}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`);